import type { Job } from "@eai-toolkit/client";
import { jobAccessUrl } from "@eai-toolkit/client";
import { CircularProgress, Link } from "@mui/material";
import { styled } from "@mui/material/styles";
import { tracker } from "@openreplay/tracker";

import { NOTEBOOKS_EVENTS } from "@helpers/events";

import { JobStates } from "../constants";

const { origin, protocol, hostname } = window.location;
const consoleSubdomain = (/((\/\/)|\.)(console(-dev)?)\./.exec(origin) ??
  [])[3];
const EAI_CONSOLE_URL = consoleSubdomain
  ? `${protocol}//${consoleSubdomain}${hostname.split(consoleSubdomain)[1]}`
  : origin;

const StyledLink = styled(Link)({
  display: "initial",
});

const StyledButton = styled("button")({
  display: "initial",
  background: "none",
  border: "none",
  color: "primary",
  cursor: "pointer",
  textDecoration: "underline",
  padding: 0,
  font: "inherit",
});

interface RelaunchControlProps {
  job: Job;
  state: string;
  handleClickRestart: () => void;
}

const RelaunchControl = (props: RelaunchControlProps) => {
  const { job, state, handleClickRestart } = props;
  switch (state) {
    case JobStates.FAILED:
    case JobStates.CANCELLED:
    case JobStates.INTERRUPTED:
      return <StyledButton onClick={handleClickRestart}>Restart</StyledButton>;
    case JobStates.RUNNING:
      return (
        <StyledLink
          color="primary"
          href={jobAccessUrl({
            job,
            // TODO: support local dev links
            EAI_CONSOLE_URL,
            human: true,
          })}
          onClick={() => tracker.event(NOTEBOOKS_EVENTS.NOTEBOOK_OPEN_CLICKED)}
        >
          Open
        </StyledLink>
      );
    case JobStates.QUEUED:
    case JobStates.QUEUING:
      return <CircularProgress size={24} />;
    default:
      return <></>;
  }
};

export default RelaunchControl;
